/**
 * This module provides CSS styling for this component.
 */
import styled from "styled-components";

const StyledContainer = styled.p`
  font-weight: bold;
`;

// Public API for this module
export { StyledContainer };
export default StyledContainer;
